import Carousel from 'react-bootstrap/Carousel';

export default function CarouselSec() {
    return (
    <div className="carousel">
        <Carousel >
      <Carousel.Item interval={1000}>
        <img
          className="d-block w-100 h-20"
          src="./images/carousel1.jpg"
          alt="First slide"
        /> 
      </Carousel.Item>
      <Carousel.Item interval={500}>
        <img
          className="d-block w-100 h-50"
          src="./images/carousel2.jpg"
          alt="Second slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100 h-20"
          src="./images/carousel3.jpg"
          alt="Third slide"
        />
      </Carousel.Item>
    </Carousel>
    </div>
    )
}
